import { type LabelHTMLAttributes, type ReactNode, useId } from 'react';

import { classlist } from '~/_shared/design-system/lib/classlist';

import './label.css';

type LabelSize = 'sm' | 'md';

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
	children?: ReactNode;
	size?: LabelSize;
}

const Label = ({
	children,
	size = 'md',
	id,
	htmlFor,
	className,
	...rest
}: LabelProps) => {
	// Instance-unique default id (explicit `id` prop wins) — see BaseButton.
	const auto_id = useId();
	return (
		<label
			{...rest}
			id={id ?? `Label-${auto_id}`}
			htmlFor={htmlFor}
			className={classlist('label', `label--${size}`, className)}
		>
			{children}
		</label>
	);
};

export type { LabelProps, LabelSize };
export { Label };
